import { isAddingNewAccount } from '../state'
import { showGoogleStatusModal } from '../../use-integration-management/state'
import { integrationService } from '../../../services/integration/integration-service'
// useI18n burada kullanılamaz, parametre olarak geçilecek
import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Adds a new Google account to the integration
 */
export const addNewGoogleAccount = async (t) => {
  
  // Mark account adding status
  isAddingNewAccount.value = true

  // Close current modal
  showGoogleStatusModal.value = false

  try {
    await integrationService.connectIntegration(6) // Google platform ID is 6
  } catch (error) {
    isAddingNewAccount.value = false
    responseHandlerService.handleError(
      error,
      t('settings.components.integrations.responseHandler.errors.googleConnection')
    )
  }
}
